<script setup lang="ts">
const { page } = useContent()

const hTags = ['inline-page', 'h1', 'h2', 'h3', 'h4', 'h5']
const toc = computed(() => {
  const hs = page.value.body?.children.filter((n) => hTags.includes(n.tag!)) ?? []

  // TODO: look inside dm-only blocks
  return hs.map((h) => {
    if (h.tag === 'inline-page') {
      return {
        inline: h.props?.page,
        depth: parseInt(h.props?.[':level'] ?? h.props?.level),
        id: '',
        text: '',
      }
    } else {
      return {
        id: h.props?.id ?? '',
        text: h.children?.map((e) => e.value).join('') ?? '',
        depth: hTags.findIndex((e) => e === h.tag!),
      }
    }
  })
})
</script>

<template>
  <nav v-if="page" class="menu table-of-contents">
    <div v-if="toc && toc.length > 3" class="toc-content">
      <img class="ornament" src="/img/ornament.png" alt="ornament" />

      <a href="#">
        <h3>{{ page.title }}</h3>
      </a>

      <ul v-if="toc" class="toc root">
        <template v-for="link in toc">
          <TableOfContentsInlineItem v-if="link.inline" :key="link.inline" :depth="link.depth" :page="link.inline" />
          <TableOfContentsItem v-else :key="link.id" :node="link" />
        </template>
      </ul>

      <img class="ornament" src="/img/ornament-inverted.png" alt="ornament" />
    </div>
  </nav>
</template>

<style lang="postcss">

.table-of-contents {
  .toc {
    list-style: none;
    margin: 0.2em 0 0 0;
    padding-left: 0;
    overflow-x: auto;

    a {
      display: block;
    }
  }
}
</style>

<style scoped lang="postcss">
.table-of-contents {
  grid-area: toc;
  align-self: start;
  position: sticky;
  top: 1rem;
  max-height: calc(100dvh - 2rem);

  display: flex;
  flex-direction: column;

  @media screen and (max-width: 950px) {
    display: none;
  }

  @media print {
    display: none;
  }

  .toc-content {
    display: contents;

    h3 {
      align-self: stretch;
      text-align: center;
      margin-top: 1rem;
      margin-bottom: 0.5rem;
      border-bottom: 2px solid var(--primary);
    }

    .toc.root {
      margin-top: 0;
      margin-bottom: 1em;
      flex: 1;
    }
  }
}
</style>
